import { ItemSummary, LayerItem } from "../../services/types";
import { capitalizeWords, parseMarkdown } from "../../utils/helpers";

interface MapItemDetailUIProps {
    item: LayerItem | undefined;
    summary: ItemSummary | undefined;
}

const getCategoryColor = (category?: string) => {
    if (!category) return; 

    switch (category?.toLowerCase()) {
        case "near term":
            return "bg-[#A3C9A8] text-[#1B4332]";
        case "mid term":
            return "bg-[#A0BFE0] text-[#102A43]";
        case "near term - unlikely to convert":
            return "bg-[#FFE29A] text-[#5F370E]";
        case "long term":
            return "bg-[#CA9DFF] text-[#49276F]";
        default:
            return "bg-gray-600 text-white";
    };
};

const MapItemDetailUI = ({ item, summary }: MapItemDetailUIProps) => {
    console.log('item:', item);

    // Format Activity Date
    const date = item?.activity_date ? new Date(item.activity_date) : null;

    const formattedDate = date
        ? `${String(date.getUTCMonth() + 1).padStart(2, '0')}/${String(date.getUTCDate()).padStart(2, '0')}/${date.getUTCFullYear()}`
        : '';

    return (
        <div className="max-w-2xl mx-auto bg-white border border-t-0 border-gray-300 shadow-lg">
            {/* Selected Item View */}
            {item && (
                <div className="mb-6 overflow-hidden">
                    {/* Header (Name) */}
                    <div className={`p-6 flex justify-between items-center ${getCategoryColor(item.category)}`}>
                        <div className="flex flex-col">
                            <h1 className="text-xl text-white font-bold uppercase tracking-wide">{item.name || "TBD"}</h1>
                        </div>
                    </div>

                    {/* General Layer Item Info */}
                    <div className="px-6 pt-4 space-y-4">
                        {/* Activity Date (hide for business discovery)*/}
                        {formattedDate &&
                            <div className="flex flex-col items-start space-y-1">
                                <span className="font-semibold text-xs">Activity Date</span>
                                <span className="text-xs">{formattedDate}</span>
                            </div>
                        }

                        {/* Description */}
                        {item?.description &&
                            <div className="flex flex-col items-start space-y-1">
                                <p className="font-bold text-xs">Description</p>
                                <div
                                    className='text-xs'
                                    dangerouslySetInnerHTML={{ __html: parseMarkdown(item?.description) }}
                                />
                            </div>
                        }

                        {/* Category */}
                        <div className="flex flex-col items-start space-y-1">
                            <span className="font-bold text-xs">Category</span>
                            <span className="text-xs">{item?.category || 'N/A'}</span>
                        </div>

                        {/* Value */}
                        {item?.value &&
                        <div className="flex flex-col items-start space-y-1">
                            <span className="font-bold text-xs">Value</span>
                            <span className="text-xs">{item?.value || 'N/A'} {item?.value ? summary?.unit_descriptor : '' }</span>
                        </div>
                        }
                    </div>

                    {/* Table Content */}
                    <div className="p-6 space-y-4 text-gray-700">
                        {item?.attributes?.length > 0 && (
                        <div className="overflow-x-auto">
                            <table className="min-w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-dark-gg text-white">
                                        <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold">Field</th>
                                        <th className="border border-gray-300 px-4 py-2 text-left text-xs font-semibold">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Attributes */}
                                    {item.attributes.map((attr) => (
                                            <tr key={attr.name} className="hover:bg-gray-50">
                                                <td className="border border-gray-300 px-4 py-2 text-xs font-medium">{capitalizeWords(attr.name)}</td>
                                                <td className="border border-gray-300 px-4 py-2 text-xs" dangerouslySetInnerHTML={{ __html: parseMarkdown(attr.value) || "N/A" }}>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default MapItemDetailUI;